export default {
    eventMap: {},
    //绑定事件
    bindEvent: function (name, callback) {
        this.eventMap[name] = callback
    },
    //调用事件
    toggleEvent: function (name, param) {
        if(this.eventMap[name]) {
            this.eventMap[name](param)
        } else {
            console.log("not defined")
        }
    },
  }
  


// WEBPACK FOOTER //
// ./src/common/js/EventHandler.js